import FieldControl from 'global/form/FieldControl';

class RadioButtonFieldControl extends FieldControl {
	constructor(fieldNodeList, rules) {
		super(fieldNodeList[0], rules);
		this.radioButtons = Array.from(fieldNodeList);
		this.attachRadioButtonEvents();
	}

	validateRule() {
		return this.radioButtons.some(button => button.checked);
	}

	attachRadioButtonEvents() {
		const eventType =
			this.field.getAttribute('data-validation-event') || 'blur';
		this.radioButtons.forEach((radioButton, i) => {
			if (i !== 0) {
				radioButton.addEventListener(eventType, () => this.validateField());
			}
		});
	}

	updateFieldErrorClass() {
		const isValid = this.isValid || this.isOptional();
		this.radioButtons.forEach(radioButton => {
			const radioButtonParent = radioButton.parentNode;
			if (radioButtonParent) {
				if (isValid) {
					radioButtonParent.classList.remove('is-invalid');
				} else {
					radioButtonParent.classList.add('is-invalid');
				}
			}
		});
	}
}

export default RadioButtonFieldControl;
